/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowUpOutlined = createIcon({
  name: 'icon-arrow-up-outlined',
  content: '<path d="M197.408339 509.514872l315.420037-315.420037 45.050902 45.050902-315.420037 315.420038z"/><path d="M783.13379 553.482514l-315.356316-315.420037 45.050902-44.987181 315.420037 315.420037z"/><path d="M544.179216 258.07094v637.212196h-63.72122v-637.212196z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconArrowUpOutlined;
